<template>
  <div class="newKeyWordStatisticsDetail-container">
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :close-on-click-modal="false"
      destroy-on-close
      center
      @close="close"
    >
      <div class="staff-chat-supervise-search">
        <!-- 筛选 -->
        <div class="serach-left">
          <el-date-picker
            v-model="filterParams.timeArray"
            size="mini"
            type="daterange"
            :editable="false"
            value-format="yyyy-MM-dd"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="handleTime"
            :picker-options="pickerOptions"
            :clearable="false"
            style="width: 240px; margin-right: 10px"
          >
          </el-date-picker>
          <el-input
            size="mini"
            suffix-icon="el-icon-search"
            style="width: 190px;margin-right: 10px"
            v-model="filterParams.wordName"
            placeholder="关键词"
            @blur="handleConsultList"
            @clear="handleConsultList"
            clearable
          >
          </el-input>
          <el-input
            size="mini"
            suffix-icon="el-icon-search"
            style="width: 190px;margin-right: 10px"
            v-model="filterParams.userName"
            placeholder="姓名"
            @blur="handleConsultList"
            @clear="handleConsultList"
            clearable
          >
          </el-input>
        </div>
        <!-- <div class="serach-right" v-if="mgctjdcdj">
        <el-button
          type="primary"
          size="mini"
          @click="handleExport"
          >导出</el-button
        >
      </div> -->
      </div>
      <!--  明细表格 -->
      <el-table
        size="small"
        :data="tableData"
        fit
        highlight-current-row
        :header-cell-style="{ background: '#F9F9F9' }"
        height="60vh"
        empty-text="暂无关键词数据"
        ref="cusChatTable"
        style="font-size: 13px"
      >
        <el-table-column
          v-if="isNewEdition"
          align="center"
          label="关键词组"
          show-overflow-tooltip
          min-width="150"
          prop="wordTypeName"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="wordName"
          label="关键词"
          show-overflow-tooltip
          min-width="150"
        ></el-table-column>
        <el-table-column
          v-if="!isNewEdition"
          align="center"
          label="归属分类"
          min-width="150"
          prop="wordTypeName"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          align="center"
          label="出现时间"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="hitCount"
          align="center"
          label="聊天内容"
          min-width="80"
        >
          <template slot-scope="scope">
            <div class="tag-wrap">
              <span class="more-users" @click="handleChactClick(scope.row, 2)"
                >查看</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="externalName"
          align="center"
          label="涉及客户"
          show-overflow-tooltip
          min-width="80"
        ></el-table-column>
        <el-table-column
          :label="isNewEdition ? '涉及员工' : '归属部门'"
          min-width="250"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <div>
              {{ isNewEdition ? scope.row.userName : scope.row.departName }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
        :childMsg="pageParms"
        :pageSizes="pageSizes"
        @callBack="callBack"
      ></Pagination>
    </el-dialog>

    <!-- 聊天弹层 旧版 -->
    <el-dialog
      :visible.sync="dialogChatVisible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      class="chat-content-dialog"
      append-to-body
      width="600px"
      center
    >
      <div class="content-container">
        <SenWordChatCommon ref="SenWordChatCommon" />
      </div>
    </el-dialog>

    <!-- 聊天内容 新版 -->
    <NewKeyWordStatisticsDetailChatContent
      ref="NewKeyWordStatisticsDetailChatContentRef"
      v-if="NewKeyWordStatisticsDetailChatContentShow"
      @chatContentClose="chatContentClose"
    />
  </div>
</template>
<script>
import {
  getConsultList,
  getStatisticalList,
  getSensitiveList,
  getUsersList,
} from "@/api/senWord/senWord.js";
import { getNewDate } from "@/utils/common.js";
/** 聊天内容弹窗 旧版*/
import SenWordChatCommon from "./SenWordChatCommon.vue";
/** 聊天内容弹窗 新版*/
import NewKeyWordStatisticsDetailChatContent from "./newKeyWordStatisticsDetailChatContent.vue";
export default {
  props: {
    /** 判断弹窗类型 1：关键词 2：敏感词 */
    type: Number,
    required: true,
  },
  components: {
    SenWordChatCommon,
    NewKeyWordStatisticsDetailChatContent,
  },
  data() {
    return {
      /** 判断绘画存档内容新旧版 */
      isNewEdition: false,
      /** 明细表格数据 */
      tableData: [],
      /** 控制dialog显示隐藏 */
      dialogVisible: false,
      /** 筛选参数 */
      filterParams: {
        /** 日期 */
        timeArray: getNewDate(),
        /** 关键词 */
        wordName: "",
        /** 姓名 */
        userName: "",
      },

      /** 分页参数 */
      pageParms: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },

      /** 分页每页条数 */
      pageSizes: [20, 50, 100, 200, 500],

      /** 当前时间日期选择器特有的选项参考下表 */
      pickerOptions: {
        /** 选中日期后会执行的回调，只有当 daterange 或 datetimerange 才生效  */
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime();
          if (maxDate) {
            this.choiceDate = "";
          }
        },

        /** 设置禁用状态，参数为当前日期，要求返回 */
        disabledDate: (time) => {
          if (this.choiceDate && this.choiceDate != null) {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.choiceDate - one;
            const maxTime = this.choiceDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      /** 控制旧版聊天内容显示隐藏 */
      dialogChatVisible: false,
      /** 控制新版聊天内容显示隐藏 */
      NewKeyWordStatisticsDetailChatContentShow: false,
      data: {},
      id: "",
    };
  },
  methods: {
    /** 给父组件调用 */
    init(item) {
      if (item) {
        console.log("ggggg",item);
        this.data = item;
        this.id = item.id;
      }
      this.isNewEdition = JSON.parse(
        window.localStorage.getItem("isNewEdition")
      );
      this.dialogVisible = true;
      console.log("调用接口了？？？1234", this.isNewEdition);
      this.getDataList(item);
    },
    /** 获取表格数据 */
    getDataList() {
      /** 请求参数 */
      let requestParams = {
        current: this.pageParms.currentPage,
        size: 20,
        wordName: this.filterParams.wordName,
        userName: this.filterParams.userName,
        startTime:
          this.filterParams.timeArray && this.filterParams.timeArray.length
            ? this.filterParams.timeArray[0]
            : "",
        endTime:
          this.filterParams.timeArray && this.filterParams.timeArray.length
            ? this.filterParams.timeArray[1]
            : "",
        // show: "ALL",
      };
      // /** 1：关键词 2：敏感词 */
      // this.type === 1
      //   ? this.getConsultList(requestParams)
      //   : this.getSensitiveList(requestParams);

      switch (this.id) {
        case "keyWordChat":
          this.getConsultList(requestParams);
          break;
        case "SensitiveWordsChat":
          this.getSensitiveList(requestParams);
          break;
        case "employeeWordsChat":
          requestParams.wordId = this.data.wordId;
          this.getUsersList(requestParams);
          break;
      }
    },

    /** 获取关键词统计表格数据 */
    getConsultList(requestParams) {
      if (this.isNewEdition) {
        /**新版 */
        getStatisticalList(
          requestParams,
          localStorage.getItem("Authorization"),
          false
        )
          .then((res) => {
            if (res && res.error && res.error.code === 200) {
              this.tableData = res.data.result;
              this.pageParms.total = res.data.total;
            }
          })
          .catch(() => {
            this.$message.error("系统繁忙，请稍后再试");
          });
      } else {
        /** 旧版 */
        getConsultList(
          requestParams,
          localStorage.getItem("Authorization"),
          false
        )
          .then((res) => {
            if (res && res.error && res.error.code === 200) {
              this.tableData = res.data.result;
              this.pageParms.total = res.data.total;
            }
          })
          .catch(() => {
            this.$message.error("系统繁忙，请稍后再试");
          });
      }
    },

    /** 获取敏感词统计表格数据 */
    getSensitiveList(requestParams) {
      if (this.isNewEdition) {
        /**新版 */
      } else {
        /** 旧版 */
        getSensitiveList(
          requestParams,
          localStorage.getItem("Authorization"),
          false
        ).then((res) => {
          this.tableData1 = res.data.result;
          this.pageparm.total = res.data.total;
          // console.log("敏感词统计-列表",res)
        });
      }
    },

    // 敏感词统计-列表
    // getSensitiveList(requestParams) {
    //   getSensitiveList(
    //     requestParams,
    //     localStorage.getItem("Authorization"),
    //     false
    //   ).then((res) => {
    //     this.tableData1 = res.data.result;
    //     this.pageparm.total = res.data.total;
    //     // console.log("敏感词统计-列表",res)
    //   });
    // },

    // 敏感词统计-员工列表
    getUsersList(requestParams) {
      getUsersList(
        requestParams,
        localStorage.getItem("Authorization"),
        false
      ).then((res) => {
        this.tableData2 = res.data.result;
        this.pageparm.total = res.data.total;
        // console.log("需求捕获图表",res)
      });
    },

    /** 点击查看聊天内容明细 */
    callBack(parm) {
      console.log(parm);
      // this.table2Params.current = parm.currentPage;
      // this.table2Params.size = parm.pageSize;
      this.getDataList();
    },

    /** 点击查看聊天内容明细 */
    handleChactClick(row, index) {
      if (this.isNewEdition) {
        /** 新版 */
        this.NewKeyWordStatisticsDetailChatContentShow = true;
        this.$nextTick(() => {
          this.$refs.NewKeyWordStatisticsDetailChatContentRef.init(row);
        });
      } else {
        /** 旧版 */
        let obj = {
          /** 员工userId */
          sendFrom: row.userId,
          /**企微客户Id */
          sendTo: row.externalUserid,
          /** 触发敏感词的信息Id */
          msgId: row.msgId,
        };
        /** 打开聊天内容 */
        this.dialogChatVisible = true;
        this.$nextTick(() => {
          // console.log(row.msgId)
          /** 获取聊天内容 */
          this.$refs.SenWordChatCommon.getData(obj, row.wordName, index, true);
        });
      }
    },

    /** 时间查询改变触发 */
    handleTime() {
      /** 请求参数 */
      let requestParams = {
        current: this.pageParms.currentPage,
        size: 20,
        wordName: this.filterParams.wordName,
        userName: this.filterParams.userName,
        startTime:
          this.filterParams.timeArray && this.filterParams.timeArray.length
            ? this.filterParams.timeArray[0] + " 00:00:00"
            : "",
        endTime:
          this.filterParams.timeArray && this.filterParams.timeArray.length
            ? this.filterParams.timeArray[1] + " 23:59:59"
            : "",
        // show: "ALL",
      };
      this.type === 1
        ? this.getConsultList(requestParams)
        : this.getSensitiveList(requestParams);
      // if (dataTime != null) {
      //   this.table2Params.startTime = dataTime[0] + hour;
      //   this.table2Params.endTime = dataTime[1] + hour2;
      // } else {
      //   this.table2Params.startTime = "";
      //   this.table2Params.endTime = "";
      // }
      // this.table2Params.current = 1;
      // this.getConsultList();
    },

    /** 关键词搜索&姓名搜索失焦触发查询 */
    handleConsultList() {
      this.pageParms.currentPage = 1;
      /** 请求参数 */
      let requestParams = {
        current: this.pageParms.currentPage,
        size: 20,
        wordName: this.filterParams.wordName,
        userName: this.filterParams.userName,
        startTime:
          this.filterParams.timeArray && this.filterParams.timeArray.length
            ? this.filterParams.timeArray[0] + " 00:00:00"
            : "",
        endTime:
          this.filterParams.timeArray && this.filterParams.timeArray.length
            ? this.filterParams.timeArray[1] + " 23:59:59"
            : "",
        // show: "ALL",
      };
      this.type === 1
        ? this.getConsultList(requestParams)
        : this.getSensitiveList(requestParams);
    },

    /** 关闭弹窗触发 */
    close() {
      console.log("触发了吗？");
      this.dialogVisible = false;
      this.$emit("newKeyWordStatisticsDetailClose");
    },

    /** 关闭聊天内容弹窗触发 */
    chatContentClose() {
      this.NewKeyWordStatisticsDetailChatContentShow = false;
    },
  },

  created() {
    // this.getDataList();
  },
};
</script>
<style lang="scss" scoped>
.newKeyWordStatisticsDetail-container {
  .staff-chat-supervise-search {
    margin-bottom: 20px;
  }
  .tag-wrap {
    cursor: pointer;
    color: #409eff;
  }
}
/deep/.el-dialog__body {
  // height:80vh;
  overflow-y: scroll;
}
</style>
